import { ReactNode } from "react";
// MUI
import { Stack } from "@mui/material";

// Context
import { ReconciliationSectionProvider } from "@DataPages/context/inventory/ReconciliationSectionContext";
import { TExtraTableProps } from "@DataPages/types/inventory/commons";

// Components
import MultiSelectFilterButtonsReconciliation from "@DataPages/components/Inventory/Layout/Reconciliation/MultiSelectFilterButtonsReconciliation.tsx";

// Types
import { IReconciliation } from "@/DataPages/types/inventory/models/reconciliation";

type ComponentProps = Readonly<{
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	data: IReconciliation[];
	extraTableProps?: TExtraTableProps;
	hasNextPage: boolean;
}>;

type ReconciliationUnitStatsProps = Readonly<{
	Component: (props: ComponentProps) => ReactNode;
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	data: IReconciliation[];
	filters: string[];
	extraTableProps?: TExtraTableProps;
	hasNextPage: boolean;
}>;

export default function ReconciliationCollapsableSection({ Component, ...props }: ReconciliationUnitStatsProps) {
	const { data, filters, extraTableProps, locationId, commissionCycleId, payPeriodId, hasNextPage } = props;

	return (
		<Stack component={"section"} alignItems={"center"} pr={4}>
			<ReconciliationSectionProvider data={data}>
				<MultiSelectFilterButtonsReconciliation filterOptions={filters} />
				<Component
					data={data}
					extraTableProps={extraTableProps}
					locationId={locationId}
					commissionCycleId={commissionCycleId}
					payPeriodId={payPeriodId}
					hasNextPage={hasNextPage}
				/>
			</ReconciliationSectionProvider>
		</Stack>
	);
}
